var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#85C4C9;}\r\n\t.st1{fill:#4F90A6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2",
    className: "st0",
    d: "M34.9,48.4c4.2,0,8.2-1.1,11.7-3.4c3.5-2.4,6.7-5.4,8.3-9.4c1.6-4,2.1-8.6,1.3-12.8 c-0.8-4.2-3.3-8.1-6.3-11.1c-3-3-6.8-5.1-11-5.9c-4.2-0.8-8.5-0.4-12.4,1.2s-7.3,4.4-9.6,8c-2.4,3.6-3.4,7.8-3.4,12h10.2 c0-2.2,0.5-4.2,1.9-6.2c4.1-5,12.1-5.9,16.9-1.7c1.5,1.6,3.8,4.9,3.4,8.3c1.3,6.4-4.2,10.9-10.9,10.9V48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st1",
    d: "M46.8,15.7c-3.2-3.1-7.4-4.8-11.9-4.8h0c-4.5,0-8.8,1.7-11.9,4.8c-3.2,3.1-4.9,7.2-4.9,11.6v37.5 h5.6V27.3c0-0.3,0-0.6,0-0.9c0.2-1.7,0.8-3.4,1.7-4.9c1-1.5,2.3-2.7,3.9-3.6l0.1,0c1.7-0.9,3.6-1.4,5.6-1.4h0c3,0,5.8,1.2,8,3.2 c2.1,2,3,4.8,3,7.7c0,2.9-0.9,5.7-3,7.7c-2.1,2-5,3.3-8,3.3v5.1c4.5,0,8.8-1.4,11.9-4.5c3.2-3.1,4.9-7.2,4.9-11.6 C51.8,22.9,50,18.8,46.8,15.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149149",
    x: 13.4,
    y: 26.9,
    className: "st0",
    width: 4.6,
    height: 32.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_3",
    className: "st1",
    d: "M34.5,20.6c1.3,0,2.6,0.4,3.7,1.1s2,1.8,2.5,3c0.5,1.2,0.6,2.6,0.4,3.9 c-0.3,1.3-0.9,2.5-1.8,3.4c-0.9,0.9-2.1,1.6-3.4,1.8c-1.3,0.3-2.7,0.1-3.9-0.4c-1.2-0.5-2.3-1.4-3-2.5s-1.1-2.4-1.1-3.7h6.7V20.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPp);
export default __webpack_public_path__ + "static/media/logoPP.41589ba74c862b5fc8c11a6769182ab2.svg";
export { ForwardRef as ReactComponent };